import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { RouterModule } from '@angular/router';

import { Country } from '@admin/models/Country.model';

import { AlertComponent } from '@shared/components/alert/alert.component';
import { Pagination } from '@shared/models/Pagination.model';

import {
  CrudHeaderComponent,
  CrudComponent,
  SearchBarComponent,
} from '@admin/components';
import { CurrenciesFormComponent } from './currencies-form/currencies-form.component';

@Component({
  selector: 'app-currencies',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    AlertComponent,
    CrudHeaderComponent,
    SearchBarComponent,
  ],
  templateUrl: '../../components/crud/crud.component.html',
  styleUrl: './currencies.component.scss',
})
export class CurrenciesComponent extends CrudComponent {
  override title: string = 'Monedas';
  override data: Pagination<Country> = new Pagination(Country);

  override handleLoadResponse(responses: any[]): void {
    if (responses[0].data) this.data.setData(responses[0].data);

    this.pagination.set(this.data.rows.length > 0);
    this.stopLoading();
  }

  override showModal(data: Country): void {
    const modalRef = this.modalService.open(CurrenciesFormComponent, {
      size: 'lg',
    });

    modalRef.componentInstance.dataId.set(data.id);
    modalRef.componentInstance.endpoint = 'admin/states';
    modalRef.componentInstance.readonly = true;
  }
}
